import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  OnInit,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { filter, ReplaySubject, switchMap } from 'rxjs';

import { Store } from '@ngrx/store';
import { GridApi, IStatusPanelParams } from 'ag-grid-enterprise';

import {
  getMissingCostRoles,
  getNumberOfUnauthorizedCalculations,
  getSelectedCalculationNodeIds,
  getUnauthorizedPlants,
} from '@cdba/core/store';

import { ComparableItem } from '../../button/compare-button/model/comparable-item.model';

@Component({
  selector: 'cdba-calculations-status-bar',
  templateUrl: './calculations-status-bar.component.html',
  styleUrls: ['./calculations-status-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class CalculationsStatusBarComponent implements OnInit {
  private readonly store = inject(Store);
  private readonly destroyRef = inject(DestroyRef);
  private readonly dataReady$ = new ReplaySubject<boolean>(1);

  comparableItems: ComparableItem[] = [];

  numberOfUnauthorizedCalculations$ = this.store.select(
    getNumberOfUnauthorizedCalculations
  );
  missingCostRoles$ = this.store.select(getMissingCostRoles);
  unauthorizedPlants$ = this.store.select(getUnauthorizedPlants);

  gridApi: GridApi;

  ngOnInit(): void {
    this.dataReady$
      .pipe(
        switchMap(() => this.store.select(getSelectedCalculationNodeIds)),
        filter((nodeIds) => nodeIds !== undefined),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe((nodeIds) => {
        this.comparableItems = [];
        nodeIds.forEach((nodeId) => {
          const nodeData = this.gridApi.getRowNode(nodeId);
          this.comparableItems.push(
            new ComparableItem(
              nodeData.data.materialNumber,
              nodeData.data.plant,
              // Use selected Calculation when comparing different Calculations of one Product
              nodeId
            )
          );
        });
      });
  }

  agInit(params: IStatusPanelParams): void {
    this.gridApi = params.api;

    this.gridApi.addEventListener('firstDataRendered', () => {
      this.dataReady$.next(true);
    });
  }
}
